import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateResourceCache,
  ResourceCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/resourceCacheRegister';
import { DeleteResourcesBulkResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseResourcesBulkDeleteParams = {
  config?: MutationConfig<DeleteResourcesBulkResponse, Api.ErrorResponse>;
};

export const useResourcesBulkDelete = (params?: UseResourcesBulkDeleteParams) =>
  useMutation(Api.deleteResourcesBulk, {
    ...params?.config,
    onSuccess: (data, { organizationId, resourceTypeId }) => {
      invalidateResourceCache(ResourceCacheEvents.DELETE, {
        organizationId,
        resourceTypeId,
      });
    },
  });
